import { useId } from "react";

import PropTypes from "prop-types";

import { PhoneFillIcon } from "@/components/data-display/icon";
import { getBorderColor } from "@/utils/helpers";

function AuthInputField({
  labelName,
  isFieldRequired,
  name,
  register,
  error,
  placeholder,
  className,
  type,
}) {
  const accessAbleId = useId();

  return (
    <div className={`w-full `}>
      <div className="mb-[.875rem] flex justify-between md:mb-[1rem]">
        <label className="text-grayDisplay-700" htmlFor={accessAbleId}>
          {labelName}
          {isFieldRequired && (
            <span className="text-required-color">&nbsp;*</span>
          )}
        </label>
      </div>

      <div className="relative w-full">
        <input
          id={accessAbleId}
          className={`${className} h-[3.5rem] w-full rounded-[10px] border  pl-[3.75rem] text-[1rem] text-grayDisplay-700 placeholder-grayDisplay-300 outline-0 focus:outline-none focus:ring-0 ${getBorderColor(
            error
          )}`}
          placeholder={placeholder}
          autoComplete={"off"}
          type={type}
          {...register(name)}
        />
        <PhoneFillIcon className="absolute left-2 top-[50%] -translate-y-[50%]" />
      </div>

      {error?.message && (
        <p className="mt-[0.35rem] text-[0.875rem] text-error-color first-letter:uppercase">
          {error?.message}
        </p>
      )}
    </div>
  );
}

AuthInputField.propTypes = {
  labelName: PropTypes.string,
  isFieldRequired: PropTypes.bool,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  register: PropTypes.func,
  error: PropTypes.object,
  className: PropTypes.string,
  type: PropTypes.string,
};

AuthInputField.defaultProps = {
  onChange: () => {},
  isFieldRequired: false,
  labelName: "Phone Number",
  placeholder: "Enter phone number",
};

export default AuthInputField;
